// extracted by mini-css-extract-plugin
module.exports = {"tiblock":"Typing_tiblock__2MAsX","ticontainer":"Typing_ticontainer__uebkW","tidot":"Typing_tidot__aJikJ","mercuryTypingAnimation":"Typing_mercuryTypingAnimation__1lP6Y"};